"use client";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useRouter } from "next/navigation";
import AutoSwipeRed from "@/app/components/AutoSwipeRed";
import google from '../../../public/assets/google.svg';
import Image from "next/image";
import onboarding1 from "@/public/assets/onboarding1.svg";
import onboarding2 from "@/public/assets/onboarding2.svg";
import onboarding3 from "@/public/assets/onboarding3.svg";
import activeCheckbox from "@/public/assets/checkmark.svg";
import inactiveCheckbox from "@/public/assets/checkmarkInactive.svg";

import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { NEXT_PUBLIC_GOOGLE_CLIENT_ID } from "@/config"



interface FormData {
  first_name: string;
  last_name: string;
  email: string;
}

export default function SignupPage() {
  const router = useRouter();
  const [isChecked, setIsChecked] = useState(false);
  const { register, handleSubmit, formState: { errors }, watch, reset } = useForm<FormData>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 4;
  
      const clientId = NEXT_PUBLIC_GOOGLE_CLIENT_ID;


  useEffect(() => {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
          router.push("/dashboard");
      }
  })


    const onSubmit = async (data: FormData) => {
      setIsSubmitting(true);
      setErrorMessage(null);

        try {
          const checkEmailResponse = await fetch('/api/auth/check-email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: data.email }),
        });
        const checkEmailData = await checkEmailResponse.json();

        if (!checkEmailResponse.ok) {
          if (checkEmailResponse.status === 409) {
            setErrorMessage(checkEmailData.message || 'This email is already registered. Please log in.');
          } else {
            throw new Error(checkEmailData.message || 'Failed to check email availability.');
          }
          setIsSubmitting(false);
          return;
        }
          localStorage.setItem("step1Data", JSON.stringify(data));
            router.push("/auth/signup/passwordStep");
            reset();
    } catch (error) {
      console.error("Signup Step 1 Error", error)
      setErrorMessage((error as Error).message || "An unexpected error occurred.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSuccess = async (credential: any) => {
    console.log("Google login response:", credential);
    setIsGoogleLoading(true);
    setErrorMessage(null);
  
    try {
      const response = await fetch("/api/auth/google", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(credential),
      });
  
      const result = await response.json();

      console.log("Backend response:", result);
      if (!response.ok) {
        if (response.status === 401) {
            setErrorMessage('Password is not correct')
        } else if (response.status === 404) {
            setErrorMessage('Email does not exist')
        } else {
            setErrorMessage(result.message || 'Login failed, please try again')
        }
        setIsGoogleLoading(false);
        return;
    }

    console.log("Success:", result);
     
    reset();
    router.push("/dashboard");
    } catch (error) {
      console.error("Error verifying Google login:", error);
      setErrorMessage("Google login failed. Please try again or use a different login method.");
      setIsGoogleLoading(false);
    }
  };


    return (
        <div className="min-h-screen flex justify-center flex-col md:flex-row items-start md:items-center">
            {(isSubmitting || isGoogleLoading) && (
                <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center">
                    <div className="flex items-center gap-3 bg-white rounded-2xl px-6 py-4 shadow-lg">
                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#BC1823]"></div>
                        <span className="text-sm font-medium text-gray-700">
                            {isGoogleLoading ? "Signing up with Google..." : "Creating account..."}
                        </span>
                    </div>
                </div>
            )}
            {errorMessage && (
                <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white p-6 rounded-lg shadow-md w-4/5 max-w-sm text-center">
                    <h2 className="text-xl font-semibold text-red-500 mb-4">Error</h2>
                    <p className="text-black-light mb-6">{errorMessage}</p>
                    <Button
                    onClick={() => setErrorMessage(null)}
                    className="bg-primary text-white w-full rounded-full h-12"
                    >
                        Close
                    </Button>
                        </div>
                </div>
            )}
          {/* Primary Background */}
           <AutoSwipeRed startIndex={0} />
            {/* Signup Form */}
            <div className="w-full md:w-1/2 flex justify-center flex-col items-center pb-4 px-4 sm:px-6 bg-white py-8 md:py-0">
                <form className="w-full max-w-md" onSubmit={handleSubmit(onSubmit)}>
                    <h1 className="text-xl sm:text-2xl font-medium text-black mb-3 md:mb-4">Create an account</h1>
                    {errorMessage && <p className="text-red-500 text-sm">{errorMessage}</p>}

                    <p className="text-black-light mb-4 md:mb-6 font-normal text-sm sm:text-base">Get started with the amazing features from Velarius Education</p>
                    
                    <div style={{ border: '1px solid #ccc', borderRadius: "24px", overflow: "hidden" }}>

  <GoogleOAuthProvider clientId={clientId}>
  <GoogleLogin
    onSuccess={handleSuccess}
    onError={() => console.log("Login Failed")}
    theme="outline"
    size="large"
    useOneTap
    auto_select={false}
    ux_mode="popup"
  />
</GoogleOAuthProvider>
</div>

                  
            
                    <div className="flex justify-center items-center w-full my-4">
                     <div className="flex items-center w-1/2">
                     <div className="flex-1 h-px bg-black-dark"></div>
                    <span className="px-3 text-[#9E9E9E] text-sm font-normal">or with</span>
                   <div className="flex-1 h-px bg-black-dark"></div>
                   </div>
                  </div>


                    {/* google ends */}

                    {/* First Name */}
                    <div className="mb-4">
                        <label className="block text-black-light">First Name</label>
                        <Input
                            type="text"
                            placeholder="e.g Tayo"
                            {...register('first_name', { required: 'First name is required' })}
                            // className={`w-full border min-h-11  mt-1 rounded-full placeholder:text-placeholder-gray ${errors.first_name ? 'border-primary' : 'border-black-dark'} focus:border-green-500`}
                            className={`w-full min-h-11 mt-1 rounded-full placeholder:text-placeholder-gray ${errors.first_name ? 'border-primary' : 'border-black-dark'} focus:border-black focus:outline-none`}

                        />
                        {errors.first_name && <p className="text-primary">{errors.first_name.message}</p>}
                    </div>

                    {/* Last Name */}
                    <div className="mb-4">
                        <label className="block text-base text-black-light">Last Name</label>
                        <Input
                            type="text"
                            placeholder="e.g Adebanjo"
                            {...register('last_name', { required: 'Last name is required' })}
                            className={`w-full min-h-11  mt-1 rounded-full placeholder:text-placeholder-gray ${errors.last_name ? 'border-primary' : 'border-black-dark'}`}
                        />
                        {errors.last_name && <p className="text-primary">{errors.last_name.message}</p>}
                    </div>

                    {/* Email */}
                    <div className="mb-4">
                        <label className="block text-base text-black-light">Enter your Email Address</label>
                        <Input
                            type="email"
                            placeholder="e.g Adeyo@gmail.com"
                            {...register('email', {
                                required: 'Email is required',
                                pattern: {
                                    // value to allow + eg +1 etc
                                    value: /^[\w-\.]+(\+[\w0-9]+)?@([\w-]+\.)+[\w-]{2,4}$/g,
                                    // value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,   (value not allow + eg +1, +2 etc)
                                    message: 'Enter a valid email'
                                }
                            })}
                            className={`w-full min-h-11  mt-1 rounded-full placeholder:text-placeholder-gray ${errors.email ? 'border-primary' : 'border-black-dark'}`}
                        />
                        {errors.email && <p className="text-primary">{errors.email.message}</p>}
                    </div>
                    {/* Terms and Conditions */}
                    <div className="mb-4 flex gap-2 items-center">
                    <div onClick={() => setIsChecked(!isChecked)} className="cursor-pointer relative w-6 h-6">
  <Image 
    src={isChecked ? activeCheckbox : inactiveCheckbox} 
    alt="Checkbox" 
    className="w-full h-full" 
  />
  </div>
                     {/* <input
                     type="checkbox"
                     id="terms"
                     checked={isChecked}
                     onChange={() => setIsChecked(!isChecked)}
                     className="peer mr-2 w-8 h-6 border appearance-none border-[#B1B1B1] bg-[#F5F5F5] rounded-sm checked:bg-red-500
                      checked:border-red-500 checked:after:content-['✔'] checked:after:text-white checked:after:text-xs 
                      checked:after:block checked:after:font-bold checked:after:relative checked:after:top-[2px] checked:after:left-[6px] focus:outline-none "
                     /> */}
                    <label htmlFor="terms" className="text-[#666666]">
                    By creating an account, you agree to our{" "} 
                     <a href="/terms-of-service" className="text-primary font-medium">Terms of use</a> and{" "} 
                     <a href="/dashboard/privacy-policy" className="text-primary font-medium">Privacy Policy</a>.
                     </label>
                    </div>
                    
  {/* {isChecked && (
    <Image 
      src={checkmark} 
      alt="Checkmark" 
      className="absolute inset-0 w-full h-full object-contain" 
    />
  )} */}
{/* <div onClick={() => setIsChecked(!isChecked)} className="cursor-pointer w-6 h-6 relative">
  <div className={`w-full h-full rounded border-2 ${isChecked ? 'bg-primary border-primary' : 'border-gray-300'}`}>
    {isChecked && (
      <Image src={checkmark} alt="Checkmark" className="absolute inset-0 p-1" />
    )}
  </div>
</div> */}



                    {/* Submit Button */}
                    <Button
                        type="submit"
                        disabled={!isChecked || isSubmitting}
                        className="w-full border-black-dark min-h-11  mt-1 rounded-full h-12 bg-primary text-white"
                    >
                        {isSubmitting ? 'Checking..' : 'Next'}
                    </Button>
                    <div className="flex justify-start text-base text-[#333333] py-2">Already have an account? 
                            <span className="">
                                <a href="/auth/login" className="text-primary font-bold underline ml-1">Login.</a>
                            </span>
                        </div>
                </form>
            </div>
        </div>
    );
}